<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex flex-column flex-md-row justify-content-between">
                            <!-- Sección Izquierda (Título) -->
                            <div class="col-12 col-md-4 text-center text-md-start mb-2 mb-md-0">
                                <h6 class="mb-2 ms-2">Registros de tiempo del {{ formatDate(startDate) }} al {{
                                    formatDate(endDate) }}</h6>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="mb-3 row">
                            <div class="col-md-2">
                                <label>Fecha de inicio:</label>
                                <input type="date" v-model="startDate" class="form-control" />
                            </div>
                            <div class="col-md-2">
                                <label>Fecha de fin:</label>
                                <input type="date" v-model="endDate" class="form-control" />
                            </div>
                            <div class="col-md-2 d-flex align-items-end mt-2">
                                <button @click="fetchData" class="btn btn-secondary w-100"
                                    style="margin-bottom: 0px;">Cargar
                                    Fechas</button>
                            </div>
                            <div class="col-md-2 d-flex align-items-end mt-2">
                                <button @click="downloadReport" class="btn btn-warning w-100"
                                    style="margin-bottom: 0px;">
                                    Descargar Reporte</button>
                            </div>
                            <div class="col-md-4">
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table id="timeRecordsTable" class="table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>Proyecto</th>
                                        <th>Cliente</th>
                                        <th>Descripción</th>
                                        <th>Nombre</th>
                                        <th>Equipo</th>
                                        <th>Email</th>
                                        <th>Actividad</th>
                                        <th>Es Facturable</th>
                                        <th>Fecha</th>
                                        <th>Total de Horas</th>
                                        <th>Autorizado?</th>
                                        <th>En Planta?</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- Los datos se insertarán aquí -->
                                    <tr v-for="record in time_records" :key="record.project">
                                        <td>{{ record.project }}</td>
                                        <td>{{ record.client }}</td>
                                        <td>{{ record.notes }}</td>
                                        <td>{{ record.full_name }}</td>
                                        <td>{{ record.team }}</td>
                                        <td>{{ record.email }}</td>
                                        <td>{{ record.activity }}</td>
                                        <td>{{ record.is_billable }}</td>
                                        <td>{{ formatISOToDDMMYYYY(record.date) }}</td>
                                        <td>{{ record.total_hours }}</td>
                                        <td>{{ record.is_auth }}</td>
                                        <td>{{ record.on_site }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import { DataTable } from 'simple-datatables'; // Importa Simple-DataTables

import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const startDate = ref(null)
const endDate = ref(null)

const time_records = ref([])


const fetchData = async () => {

    if (!startDate.value || !endDate.value) {
        alert("Por favor selecciona ambas fechas.");
        return;
    }
    const body = {
        start_date: startDate.value,
        end_date: endDate.value
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/time-records-by-interval`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        time_records.value = response.data
    } catch (error) {
        console.error("Error al cargar clientes:", error);
    }
};

const downloadReport = async () => {

    try {
        const response = await axios.post(`${API_BASE_URL}/download-time-records-by-interval`, {
            start_date: startDate.value,
            end_date: endDate.value
        }, {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'reporte-registros-tiempo.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (err) {
        console.error('Error al descargar el reporte:', err);
    }
};

// Format date as "dd/MM/yyyy"
const formatDate = (date) => {
    if (!date) return '';

    const d = new Date(date + 'T00:00:00'); // <-- Fuerza hora local
    if (isNaN(d.getTime())) return '';

    return d.toLocaleDateString('es-ES', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    });
}

function formatISOToDDMMYYYY(isoDateString) {
    const date = new Date(isoDateString)

    // Asegura usar los datos en UTC para evitar desfase
    const day = String(date.getUTCDate()).padStart(2, '0')
    const month = String(date.getUTCMonth() + 1).padStart(2, '0')
    const year = date.getUTCFullYear()

    return `${day}/${month}/${year}`
}

let dataTableInstance = null

onMounted(async () => {
    const now = new Date()
    const year = now.getFullYear()
    const month = now.getMonth()

    // Primer día del mes
    const firstDay = new Date(year, month, 1)
    // Último día del mes
    const lastDay = new Date(year, month + 1, 0)

    // Asignamos las fechas formateadas como YYYY-MM-DD
    startDate.value = firstDay.toISOString().split('T')[0]
    endDate.value = lastDay.toISOString().split('T')[0]

    await fetchData();

    // Si la tabla ya existe, destrúyela antes de inicializar
    if (dataTableInstance) {
        dataTableInstance.destroy();
    }

    // Inicializar DataTable
    dataTableInstance = new DataTable('#timeRecordsTable', {
        searchable: true,
        perPage: 10,
        perPageSelect: [5, 10, 15, 20],
        labels: {
            placeholder: "Buscar...",
            perPage: "entradas por página",
            noRows: "No se encontraron registros",
            info: "Mostrando {start} a {end} de {rows} entradas",
        },
    });
});

</script>